import { writable } from 'svelte/store';
export var QrCodeDialogStore;
(function (QrCodeDialogStore) {
    // 画像プレビュー
    class ShowData {
        constructor() {
            this.size = 150;
        }
    }
    QrCodeDialogStore.ShowData = ShowData;
    QrCodeDialogStore.showData = writable(null);
})(QrCodeDialogStore || (QrCodeDialogStore = {}));
